<template>
  <a-card>
    <InfoEmployee
      :user="detailUser"
      :loadingItem="loadingTable"
      :updateEmployeeOnView="updateEmployeeOnView"
    />
  </a-card>
</template>
<script>
import moment from "moment";
import InfoEmployee from "./detailUser/infoUser";
import { queryGetDetailUser } from "../data/getData";

export default {
  components: {
    InfoEmployee,
  },
  data() {
    return {
      loadingTable: true,
      loadingUpdate: false,
      loadingDelete: false,
      detailUser: {},
    };
  },
  methods: {
    showDrawerUpdateEmployee() {
      this.visibleUpdateEmployee = true;
    },
    moment,
    getUser() {
      this.loadingTable = true;
      this.$apollo
        .query({
          query: queryGetDetailUser,
          variables: {
            id: this.$route.params?.idUser,
          },
          fetchPolicy: "no-cache",
        })
        .then(({ data }) => {
          if (data?.getUser) {
            this.detailUser = { ...data.getUser };
          }
          this.loadingTable = false;
        })
        .catch((error) => {
          this.$notification.error({
            message: "Thông báo",
            description: "Không lấy được chi tiết nhân viên",
          });
          console.log("Không lấy được chi tiết nhân viên", error);
        });
    },
    updateEmployeeOnView(user) {
      this.detailUser = { ...this.detailUser, ...user };
    },
    refreshEmployeeAfterLeaveAnualUpdated(annualLeaveDay) {
      this.detailUser = { ...this.detailUser, annualLeaveDay };
    },
    refreshEmployeeAfterSickDayUpdated(sickLeaveDay) {
      this.detailUser = { ...this.detailUser, sickLeaveDay };
    },
  },
  created() {
    this.getUser();
  },
};
</script>
<style scoped>
.ant-form-item {
  margin-bottom: 0px;
}
.card-6 >>> .ant-card-body {
  padding: 6px !important;
  padding-top: 24px !important;
}
</style>
